/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc アンケート画面
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-dialog ref="dialog" :visible.sync="dialogVisible" class="el-message-box__wrapper" custom-class="el-message-box fc-survey-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
  <el-container>
    <el-main class="main-area">
      <el-form class="survey-form" ref="fastchatSurveyResultForm" :model="fastchatSurveyResult" :rules="rules">
        <div class="survey-form-table-wrapper">
          <table class="survey-form-table">
            <tr class="survey-title-tr" v-show="isShowSurveyTitle">
              <td>
                <span>{{this.$root.$config.surveyWindowConfig.surveyTitle}}</span>
              </td>
            </tr>
            <tr class="evaluation-point-tr" v-show="isShowEvaluationPoint">
              <td class="evaluation-point-td">
                <el-form-item class="evaluation-point-wrapper" prop="evaluationPoint">
                  <el-rate v-model="fastchatSurveyResult.evaluationPoint" class="evaluation-point"></el-rate>
                </el-form-item>
              </td>
            </tr>
            <tr class="comment-title-tr" v-show="isShowCommentTitle">
              <td>
                <span>{{this.$root.$config.surveyWindowConfig.commentTitle}}</span>
              </td>
            </tr>
            <tr class="comment-textarea-tr" v-show="isShowCommentText">
              <td>
                <el-form-item class="comment-textarea-wrapper" prop="commentText">
                  <el-input v-model="fastchatSurveyResult.commentText" class="comment-textarea" ref="commentTextarea" type="textarea" resize="none"></el-input>
                </el-form-item>
              </td>
            </tr>
          </table>
        </div>
      </el-form>
    </el-main>
    <el-footer class="footer-area" height="auto">
      <el-button @click="closeHandler">{{closeButtonLabel}}</el-button>
      <el-button type="primary" :disabled="!permissionSend" @click="sendHandler">{{$t('送信')}}</el-button>
    </el-footer>
  </el-container>
</el-dialog>
</template>

<script>
import {
  Container,
  Main,
  Footer,
  Dialog,
  Button,
  Rate,
  Input,
  Form,
  FormItem
} from 'element-ui'
import ServiceUtil from '@/utils/ServiceUtil'

export default {
  name: 'FcSurveyDialog',
  components: {
    'el-container': Container,
    'el-main': Main,
    'el-footer': Footer,
    'el-dialog': Dialog,
    'el-button': Button,
    'el-rate': Rate,
    'el-input': Input,
    'el-form': Form,
    'el-form-item': FormItem
  },
  data() {
    return {
      fastchatSurveyResult: {
        evaluationPoint: 0,
        commentText: '',
        callSpecificKey: ''
      },
      rules: {
        commentText: [{
          max: this.$root.$config.surveyWindowConfig.surveyCommentTextMaxLength,
          message: this.$t('{surveyCommentTextMaxLength} 文字以内にしてください', {
            surveyCommentTextMaxLength: this.$root.$config.surveyWindowConfig.surveyCommentTextMaxLength
          }),
          trigger: 'change'
        }]
      },
      dialogVisible: false,
      validFastchatSurveyResultForm: false,
      closeCallbackFunc: null,
      closeButtonLabel: this.$t('終了')
    }
  },
  mounted() {
    setTimeout(_ => {
      this.validateFastchatSurveyResultForm((valid) => {
        this.validFastchatSurveyResultForm = valid
      })
      this.$refs['commentTextarea'].resizeTextarea()
    }, 100)
  },
  updated() {
    this.validateFastchatSurveyResultForm((valid) => {
      this.validFastchatSurveyResultForm = valid
    })
  },
  computed: {
    /**
     * タイトルを表示するか
     * @return {Boolean}
     */
    isShowSurveyTitle() {
      const surveyTitle = this.$root.$config.surveyWindowConfig.surveyTitle
      return surveyTitle != null && surveyTitle.length > 0
    },
    /**
     * アンケート評価点を表示するか
     * @return {Boolean}
     */
    isShowEvaluationPoint() {
      return this.$root.$config.surveyWindowConfig.useEvaluationPoint
    },
    /**
     * アンケートコメント説明を表示するか
     * @return {Boolean}
     */
    isShowCommentTitle() {
      const commentTitle = this.$root.$config.surveyWindowConfig.commentTitle
      return this.$root.$config.surveyWindowConfig.useComment && commentTitle != null && commentTitle.length > 0
    },
    /**
     * アンケートコメントを表示するか
     * @return {Boolean}
     */
    isShowCommentText() {
      return this.$root.$config.surveyWindowConfig.useComment
    },
    /**
     * 送信可能か
     * @return {Boolean}
     */
    permissionSend() {
      return this.validFastchatSurveyResultForm
    }
  },
  methods: {
    /**
     * 初期化します
     * @param  {String} callSpecificKey 対象コール特定キー
     * @param  {Function} closeCallbackFunc ダイアログを閉じる際実行されるコールバックファンクション
     * @param  {String} closeButtonLabel 終了ボタンのラベル
     */
    init(callSpecificKey, closeCallbackFunc, closeButtonLabel) {
      this.dialogVisible = true
      this.fastchatSurveyResult.commentText = ''
      this.fastchatSurveyResult.evaluationPoint = this.$root.$config.surveyWindowConfig.defaultEvaluationPoint || 0
      this.fastchatSurveyResult.callSpecificKey = callSpecificKey
      this.closeCallbackFunc = closeCallbackFunc
      this.closeButtonLabel = closeButtonLabel || this.$t('終了')
    },
    /**
     * アンケート結果フォームの入力チェック
     * @param  {Function} callback
     */
    validateFastchatSurveyResultForm(callback) {
      if (this.$refs['fastchatSurveyResultForm']) {
        this.$refs['fastchatSurveyResultForm'].validate((valid) => {
          callback(valid)
        })
      }
    },
    /**
     * 送信処理
     */
    sendHandler() {
      const param = {
        fastchatSurveyResult: this.fastchatSurveyResult
      }
      if (!this.isShowEvaluationPoint) {
        param.fastchatSurveyResult.evaluationPoint = null
      }
      ServiceUtil.request('sendSurveyResult', param, {
        end: this.closeDialog
      })
    },
    /**
     * 終了処理
     */
    closeHandler() {
      this.closeDialog()
    },
    /**
     * アンケート画面を閉じる
     */
    closeDialog() {
      this.dialogVisible = false
      if (this.closeCallbackFunc) {
        this.closeCallbackFunc()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatWindow/dialog/FcSurveyDialog.vue